import { CSSProperties, FC } from 'react';
import { ENV_CONFIG } from 'config/environment';
import { getPathWithRef } from 'helpers/utils';

interface Props {
  image?: string;
  caption: string;
  title: string;
  description: string;
  cta: string;
  ctaLink: string;
}

export const SelectableCard: FC<Props> = ({ image, caption, title, description, cta, ctaLink }) => {
  return (
    <a
      className="selectable-card"
      href={getPathWithRef(ctaLink)}
      style={
        image
          ? ({
              '--selectable-card-image': `url(${ENV_CONFIG().CLOUD_STORAGE.URL}/${image})`,
            } as CSSProperties)
          : undefined
      }
    >
      <span className="eyebrow-text">{caption}</span>
      <span className="h4-text semi-bold color-white">{title}</span>
      <span className="body-small-text color-white">{description}</span>
      <span className="selectable-card-cta">{cta}</span>
    </a>
  );
};
